export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_TOKEN_KEY = 'mitzva_admin_token';

// Helper: fetch with admin token header. Reads token from sessionStorage (set on login).
// 401 handling: only bounce to login if the user is currently considered authenticated
// AND we get a clean 401. Avoids racing/transient errors from clearing session prematurely.
export const adminFetch = (path, options = {}) => {
  const token = sessionStorage.getItem(ADMIN_TOKEN_KEY) || '';
  return fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      'X-Admin-Token': token,
    },
  }).then((res) => {
    if (res.status === 401 && token) {
      // Token confirmed invalid by backend. Clear it; the consumer effect will react.
      sessionStorage.removeItem(ADMIN_TOKEN_KEY);
      window.dispatchEvent(new Event('adminUnauthorized'));
    }
    // Any successful admin mutation → refresh the storefront instantly
    const method = (options.method || 'GET').toUpperCase();
    if (res.ok && method !== 'GET') {
      window.dispatchEvent(new Event('productsUpdated'));
    }
    return res;
  });
};

export const statusColors = {
  'Nuevo': 'bg-blue-500',
  'En Proceso': 'bg-yellow-500',
  'Enviado': 'bg-purple-500',
  'Entregado': 'bg-green-500',
  'Cancelado': 'bg-red-500'
};
export const statusOptions = ['Nuevo', 'En Proceso', 'Enviado', 'Entregado', 'Cancelado'];
export const uploadProductImage = async (file, kind = 'gallery') => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('kind', kind);
  const token = sessionStorage.getItem(ADMIN_TOKEN_KEY) || '';
  const res = await fetch(`${API_URL}/api/admin/uploads`, {
    method: 'POST',
    headers: { 'X-Admin-Token': token },
    body: fd,
  });
  if (!res.ok) throw new Error(`Upload failed: ${res.status}`);
  const data = await res.json();
  return data.url;
};

export const PRODUCT_MATERIALS = [
  { id: 'lana', label: 'Lana' },
  { id: 'algodon', label: 'Algodón' },
  { id: 'bambu', label: 'Bambú' },
  { id: 'poliester', label: 'Poliéster' },
  { id: 'otro', label: 'Otro' },
];
export const PRODUCT_STYLES = ['T-Shirt', 'Tank Top', 'Tank Top V-Neck', 'Oversized T-Shirt', 'Jersey', 'Kol Haposkim', 'Talit Gadol', 'Otro'];
export const FABRIC_MAP = {
  lana: { es: '100% Lana', en: '100% Wool' },
  algodon: { es: '100% Algodón', en: '100% Cotton' },
  bambu: { es: '95% Viscosa de Bambú 5% Spandex', en: '95% Bamboo Viscose 5% Spandex' },
  poliester: { es: '95% Poliéster 5% Spandex', en: '95% Polyester 5% Spandex' },
};
